import { useEffect } from 'react';
import { store, storeActions, useSirenEntity, useStoreValues } from '~/runtime';
/**
 * Loads the current organization and updates the store.organizationSettings & store.organizationType values
 */
export function useCurrentOrganizationWatcher() {
  const { currentOrgHref, token } = useStoreValues(['currentOrgHref', 'token']);
  const { entity } = useSirenEntity({ href: token && currentOrgHref });

  useEffect(() => {
    store.dispatch(storeActions.setOrganizationSettings(entity?.properties.settings));
    const organizationType = entity?.getSubEntityByRel('https://api.binsentry.com/rel/organization-type').properties.name;
    store.dispatch(storeActions.setOrganizationType(organizationType));
  }, [entity]);
}
